const organizations = state => state.organizations;
const organizationsLoaded = state => state.organizationsLoaded;
const editedOrganization = state => state.editedOrganization;
const memberOrganization = state => state.memberOrganization;
const organizationMembersResponseObject = state =>
  state.organizationMembersResponseObject;
const membersResponseObjectLoaded = state => state.membersResponseObjectLoaded;
const mobileOrganization = state => state.mobileOrganization;
const mobileOrganizationLoaded = state => state.mobileOrganizationLoaded;
const organizationChallenges = state => state.organizationChallenges;
const organizationChallengesLoaded = state =>
  state.organizationChallengesLoaded;
const organizationTeams = state => state.organizationTeams;

export default {
  organizations,
  organizationsLoaded,
  editedOrganization,
  memberOrganization,
  organizationMembersResponseObject,
  membersResponseObjectLoaded,
  mobileOrganization,
  mobileOrganizationLoaded,
  organizationChallenges,
  organizationChallengesLoaded,
  organizationTeams
};
